import { NavigationItem } from 'src/app/core/components/pages-container/interfaces/navigationList.interface';

export const routes: NavigationItem[] = [
  {
    id: 1,
    name: 'Invoices',
    iconClass: 'icon-invoice-solid',
    routeUrl: '/invoices',
    children: [],
    permissions: ['ClientClientInvoicesView'],
  },
  {
    id: 2,
    name: 'Route Sheet',
    iconClass: 'icon-blueprint-solid',
    routeUrl: '/route-sheet',
    children: [],
    permissions: ['RideBlueprintView'],
  },
  {
    id: 3,
    name: 'Active Rides',
    iconClass: 'icon-car-solid',
    routeUrl: '/dispatch/monitoring-center/rides',
    children: [],
    permissions: ['RideMonitorView'],
  },
  {
    id: 4,
    name: 'Places',
    iconClass: 'icon-map-pin-area-solid',
    routeUrl: '/places',
    children: [],
    permissions: ['ClientPlacesView'],
  },
  {
    id: 5,
    name: 'Passengers',
    iconClass: 'icon-users-three-solid',
    routeUrl: '/passengers',
    children: [
      {
        id: 7,
        name: 'Students',
        iconClass: 'icon-student',
        routeUrl: '/passengers/students',
        children: [],
        permissions: ['ClientStudentsView'],
      },
      {
        id: 8,
        name: 'Guardians App Users',
        iconClass: 'icon-shield-star',
        routeUrl: '/passengers/guardians-app-users',
        children: [],
        permissions: ['ClientGuardiansView'],
      },
    ],
  },
  {
    id: 6,
    name: 'Reports',
    iconClass: 'icon-files-solid',
    routeUrl: '/reports',
    children: [
      {
        id: 9,
        name: 'Historical Rides',
        iconClass: 'icon-calendar',
        routeUrl: '/reports/historical-rides-report',
        children: [],
        permissions: ['ClientRideFinderReportView'],
      },
      {
        id: 10,
        name: 'No Show Report',
        iconClass: 'icon-eye-slash',
        routeUrl: '/reports/no-show-report',
        children: [],
        permissions: ['ClientNoShowReportView'],
      },
      {
        id: 11,
        name: 'Consecutive No Show Report',
        iconClass: 'icon-fast-forward',
        routeUrl: '/reports/consecutive-no-show-report',
        children: [],
        permissions: ['ClientConsecutiveNoShowReportView'],
      }
    ],
  },
];
